import { useMutation, useQueryClient } from '@tanstack/react-query'
import React from 'react'
import toast from 'react-hot-toast';
import { addRelativeCompAnalysis as addRelativeCompAnalysisAPI} from 'services/apiRelativeCompAnalysis';

const useAddRelativeComp = () => {
  const queryClient = useQueryClient();
  const{isPending: isAdding, isSuccess: isAdded, mutate: addRelativeCompAnalysis} = useMutation({
    mutationFn: addRelativeCompAnalysisAPI,
    onSuccess:(data)=>{
        queryClient.setQueryData(['newRelativeCompData'],data)
    },
    onError:(error)=>{
        console.log("Error occurred when creating Org",error)
                if (error?.data && typeof error.data === 'object') {
                // Display all backend validation errors
                for (const key in error.data) {
                    const msg = error.data[key];
                    toast.error(Array.isArray(msg) ? msg[0] : msg);
                }
            } else {
                toast.error(error.message || "Something went wrong.");
            }
    }
  })

  return{isAdding, isAdded, addRelativeCompAnalysis}
}

export default useAddRelativeComp